"use client";
import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api'; 
import { Trash2, Plus, Edit, CalendarDays } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ModalHorario = ({ isOpen, onClose, onSave, horario, grupo, loadingHorarios }) => {
    const [formData, setFormData] = useState({ dia_da_semana: 'domingo', hora: '', rotulo: '', data_especifica: '' });
    const [isDataImportante, setIsDataImportante] = useState(false);
    const [formError, setFormError] = useState('');
    const diasDaSemana = ['domingo', 'segunda-feira', 'terca-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sabado'];

    useEffect(() => {
        if (horario) {
            const isSpecialDate = !!horario.data_especifica;
            setIsDataImportante(isSpecialDate);
            setFormData({
                dia_da_semana: horario.dia_da_semana || 'domingo',
                hora: horario.hora ? horario.hora.slice(0, 5) : '',
                rotulo: horario.rotulo || '',
                data_especifica: horario.data_especifica ? new Date(horario.data_especifica).toISOString().split('T')[0] : ''
            });
        } else {
            setIsDataImportante(false);
            setFormData({ dia_da_semana: 'domingo', hora: '', rotulo: '', data_especifica: '' });
        }
    }, [horario, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (name === 'hora') {
            if (!/^\d{2}:\d{2}$/.test(value)) {
                setFormError('Hora inválida. Use o formato HH:MM.');
            } else {
                setFormError('');
            }
        }
    };

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsDataImportante(checked);
        if (checked) {
            setFormData(prev => ({ ...prev, dia_da_semana: null }));
        } else {
            setFormData(prev => ({ ...prev, data_especifica: null, dia_da_semana: 'domingo' }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (loadingHorarios) return; // Bloqueia duplo submit
        if (!grupo?.grupo_id) {
            alert('Erro: ID do grupo não encontrado. Não é possível salvar.');
            return;
        }
        if (isDataImportante && !formData.data_especifica) {
            alert('Por favor, preencha a data específica.');
            return;
        }
        if (!formData.hora || !/^\d{2}:\d{2}$/.test(formData.hora)) {
            setFormError('Preencha uma hora válida no formato HH:MM.');
            return;
        }

        
        let diaDaSemanaFinal = formData.dia_da_semana;

        
        if (isDataImportante && formData.data_especifica) {
            
            const diasBackend = ['domingo', 'segunda-feira', 'terca-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sabado'];

            const [ano, mes, dia] = formData.data_especifica.split('-').map(Number);
            const dataObjeto = new Date(ano, mes - 1, dia); 

           
            diaDaSemanaFinal = diasBackend[dataObjeto.getDay()];
        }
        

        const dataToSubmit = {
            ...formData,
            paroquia_id: grupo.paroquia_id,
            comunidade_id: grupo.comunidade_id,
            grupo_id: grupo.grupo_id,
            dia_da_semana: diaDaSemanaFinal,
            data_especifica: isDataImportante ? formData.data_especifica : null,
        };
        onSave(dataToSubmit, horario?.id);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4" aria-modal="true" role="dialog">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-lg animate-fade-in-scale">
                <h2 className="text-xl font-bold mb-4">{horario ? 'Editar Horário' : 'Novo Horário'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 flex items-center">
                        <input type="checkbox" id="data_importante_check" checked={isDataImportante} onChange={handleCheckboxChange} className="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500" />
                        <label htmlFor="data_importante_check" className="ml-2 block text-sm font-medium text-slate-700">É uma data importante/específica?</label>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {isDataImportante ? (
                            <div className="sm:col-span-1"><label className="block text-sm font-medium text-slate-700">Data Específica</label><input type="date" name="data_especifica" value={formData.data_especifica} onChange={handleChange} required className="mt-1 w-full p-2 border border-slate-300 rounded-md shadow-sm" /></div>
                        ) : (
                            <div className="sm:col-span-1"><label className="block text-sm font-medium text-slate-700">Dia da Semana</label><select name="dia_da_semana" value={formData.dia_da_semana} onChange={handleChange} className="mt-1 w-full p-2 border border-slate-300 rounded-md shadow-sm">{diasDaSemana.map(dia => <option key={dia} value={dia}>{dia.charAt(0).toUpperCase() + dia.slice(1).replace('-feira', '')}</option>)}</select></div>
                        )}
                        <div className="sm:col-span-1"><label className="block text-sm font-medium text-slate-700">Hora</label><input type="time" name="hora" value={formData.hora} onChange={handleChange} required className="mt-1 w-full p-2 border border-slate-300 rounded-md shadow-sm" /></div>
                        <div className="sm:col-span-2"><label className="block text-sm font-medium text-slate-700">Rótulo</label><input type="text" name="rotulo" value={formData.rotulo} onChange={handleChange} required placeholder="Ex: Encontro, Missa, Terço" className="mt-1 w-full p-2 border border-slate-300 rounded-md shadow-sm" /></div>
                    </div>
                    {formError && <div className="text-red-500 mt-2">{formError}</div>}
                    <div className="flex justify-end mt-6 space-x-3">
                        <button type="button" onClick={() => { setFormError(''); onClose(); }} className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg font-semibold hover:bg-slate-300" disabled={!!formError}>Cancelar</button>
                        <button type="submit" className="px-6 py-2 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 flex items-center gap-2" disabled={!!formError || loadingHorarios}>
                            {loadingHorarios ? (
                                <span>
                                    <svg className="inline mr-2 animate-spin" width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" opacity="0.3"/><path d="M12 2a10 10 0 0 1 10 10" stroke="white" strokeWidth="4" fill="none"/></svg>
                                    {horario ? 'Atualizando...' : 'Salvando...'}
                                </span>
                            ) : (
                                horario ? 'Atualizar' : 'Salvar'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const ModalExclusao = ({ onConfirm, onCancel, loading }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4" aria-modal="true" role="dialog">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 animate-fade-in-scale">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Confirmar Exclusão</h2>
            <p className="text-slate-600">Tem a certeza que deseja excluir este horário?</p>
            <div className="mt-6 flex justify-end gap-3">
                <button onClick={onCancel} className="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 font-semibold" disabled={loading}>Cancelar</button>
                <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold" disabled={loading}>{loading ? 'Excluindo...' : 'Excluir'}</button>
            </div>
        </div>
    </div>
);


export default function GerenciadorHorarios({ grupo, usuarioPainel, token }) { 
    const [horarios, setHorarios] = useState([]);
    const [loadingHorarios, setLoadingHorarios] = useState(true);
    const [error, setError] = useState('');
    const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
    const [idParaExcluir, setIdParaExcluir] = useState(null);
    const [modalFormAberto, setModalFormAberto] = useState(false);
    const [horarioSelecionado, setHorarioSelecionado] = useState(null);
    const [loadingExcluir, setLoadingExcluir] = useState(false);
    const abortControllerRef = useRef(null);
    const [tabSelecionada, setTabSelecionada] = useState('ativos');
    const horariosAtivos = horarios.filter(h => h.ativo);
    const horariosInativos = horarios.filter(h => !h.ativo);
    
    
    const formatarData = (dataString, horaString) => {
        if (!dataString) return '';
        let dataPart = dataString;
        if (dataString.includes('T')) {
            dataPart = dataString.split('T')[0];
        }
        let horaTratada = horaString;
        if (horaTratada) {
            horaTratada = horaTratada.split('.')[0];
            if (/^\d{2}:\d{2}$/.test(horaTratada)) {
                horaTratada += ':00';
            }
        }
        let dateTimeStr = dataPart;
        if (horaTratada) {
            dateTimeStr = `${dataPart}T${horaTratada}Z`;
        } else {
            dateTimeStr = `${dataPart}T00:00:00Z`;
        }
        const d = new Date(dateTimeStr);
        if (isNaN(d.getTime())) return 'Data Inválida';
        const diaUTC = String(d.getUTCDate()).padStart(2, '0');
        const mesUTC = String(d.getUTCMonth() + 1).padStart(2, '0');
        const anoUTC = d.getUTCFullYear();
        if (horaTratada) {
            const horaUTC = String(d.getUTCHours()).padStart(2, '0');
            const minUTC = String(d.getUTCMinutes()).padStart(2, '0');
            return `${diaUTC}/${mesUTC}/${anoUTC} ${horaUTC}:${minUTC}`;
        }
        return `${diaUTC}/${mesUTC}/${anoUTC}`;
    };

    const slugify = (text) => {
        if (!text) return '';
        return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
    };

    const fetchHorarios = useCallback(async (isBackground = false) => {
        if (!grupo || !token) return;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new window.AbortController();
        
        const slugify = (text) => {
            return String(text || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-');
        }
        const paroquiaSlug = slugify(grupo.paroquia);
        const comunidadeSlug = slugify(grupo.comunidade);
        const grupoSlug = slugify(grupo.tipo); 
        try {
            setError('');
            if (!isBackground) setLoadingHorarios(true);
            const response = await api.get(`/horarios-admin/${paroquiaSlug}/${comunidadeSlug}/${grupoSlug}`, {
                headers: { Authorization: `Bearer ${token}` },
                signal: abortControllerRef.current.signal
            });
            setHorarios(response.data.horarios || []);
        } catch (err) {
            if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
                setError('Falha ao carregar os horários do grupo.');
            }
        } finally {
            if (!isBackground) setLoadingHorarios(false);
        }
    }, [grupo, token]);

    useEffect(() => {
        if (grupo && token) {
            fetchHorarios();
        }
        return () => {
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [grupo, token, fetchHorarios]);

    const handleSave = useCallback(async (data, id) => {
        try {
            let savedHorario;
            if (id) { 
                const res = await api.put(`/horarios-admin/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }); 
                savedHorario = res.data;
                savedHorario.ativo = savedHorario.ativo === 1 || savedHorario.ativo === true;
                setHorarios(prev => prev.map(h => h.id === id ? { ...h, ...savedHorario } : h));
            } 
            else { 
                const res = await api.post('/horarios-admin', data, { headers: { Authorization: `Bearer ${token}` } }); 
                savedHorario = res.data;
                savedHorario.ativo = savedHorario.ativo === 1 || savedHorario.ativo === true;
                setHorarios(prev => [...prev, savedHorario]);
            }
            setModalFormAberto(false);
            setError('');
            toast.success('Horário salvo com sucesso!');
            fetchHorarios(true);
        } catch (err) {
            setError('Erro ao salvar o horário. Verifique os dados e tente novamente.');
            toast.error('Erro ao salvar o horário.');
        }
    }, [token, fetchHorarios]);

    const handleDelete = useCallback((id) => {
        setIdParaExcluir(id);
        setModalExcluirAberto(true);
        setError('');
    }, []);

    const excluirConfirmado = useCallback(async () => {
        setLoadingExcluir(true);
        try {
            await api.delete(`/horarios-admin/${idParaExcluir}`, { headers: { Authorization: `Bearer ${token}` } });
            setHorarios(prev => prev.filter(h => h.id !== idParaExcluir));
            setModalExcluirAberto(false);
            setError('');
            toast.success('Horário excluído com sucesso!');
            fetchHorarios(true);
        } catch (err) {
            toast.error('Erro ao excluir o horário porque foi utilizado na escala.');
            setModalExcluirAberto(false);
        } finally {
            setLoadingExcluir(false);
        }
    }, [idParaExcluir, token, fetchHorarios]);

    const handleToggleStatus = useCallback(async (horario) => {
        if (!horario?.id) return;
        // Atualização otimista local
        setHorarios(prev => prev.map(h => h.id === horario.id ? { ...h, ativo: !horario.ativo } : h));
        try {
            await api.put(`/horarios-admin/${horario.id}`, { ...horario, ativo: !horario.ativo }, { headers: { Authorization: `Bearer ${token}` } });
            toast.success(`Horário ${!horario.ativo ? 'ativado' : 'inativado'} com sucesso!`);
            fetchHorarios(true);
        } catch (err) {
            // Reverter estado local em caso de falha
            setHorarios(prev => prev.map(h => h.id === horario.id ? { ...h, ativo: horario.ativo } : h));
            toast.error('Erro ao alterar o status do horário.');
        }
    }, [token, fetchHorarios]);

    // Permissão: só coordenador OU admin pode acessar
    const roles = (usuarioPainel?.roles || []).map(r => r.toLowerCase());
    if (!roles.includes('coordenador') && !roles.includes('admin')) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
                <div className="bg-white p-8 rounded-xl shadow text-center max-w-md">
                    <h2 className="text-2xl font-bold text-red-600 mb-2">Acesso negado</h2>
                    <p className="text-gray-700 mb-6">Você não tem permissão para acessar este painel.</p>
                </div>
            </div>
        );
    }
    if (!grupo && !error) {
        return <div className="p-8 text-center">Carregando dados do grupo...</div>;
    }

    return (
        <div className="font-sans">
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <style>{`.animate-fade-in-scale { animation: fadeInScale 0.3s ease-out forwards; } @keyframes fadeInScale { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }`}</style>
            <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-6">
                <h2 className="text-xl font-bold text-slate-700">Gestão de Horários do Grupo: <span className="text-indigo-600">{grupo?.tipo}</span></h2>
                <button onClick={() => { setHorarioSelecionado(null); setModalFormAberto(true); setError(''); }} className="mt-4 sm:mt-0 bg-indigo-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-indigo-700 transition-colors flex items-center gap-2" disabled={!grupo?.grupo_id || loadingHorarios}><Plus size={20} /> {loadingHorarios ? 'Carregando...' : 'Adicionar Horário'}</button>
            </div>
            {error && <p className="text-red-500 bg-red-100 p-3 rounded-md mb-4">{error}</p>}
            <div className="mb-4">
                <div className="inline-flex rounded-lg shadow overflow-hidden border border-slate-200">
                    <button
                        className={`px-6 py-2 text-sm font-semibold focus:outline-none transition-colors ${tabSelecionada === 'ativos' ? 'bg-indigo-600 text-white' : 'bg-white text-slate-700 hover:bg-slate-100'}`}
                        onClick={() => setTabSelecionada('ativos')}
                    >Ativos</button>
                    <button
                        className={`px-6 py-2 text-sm font-semibold focus:outline-none transition-colors ${tabSelecionada === 'inativos' ? 'bg-indigo-600 text-white' : 'bg-white text-slate-700 hover:bg-slate-100'}`}
                        onClick={() => setTabSelecionada('inativos')}
                    >Inativos</button>
                </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-slate-200">
                        <thead className="bg-slate-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Dia / Data</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Hora</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Rótulo</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Status</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase">Ações</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200">
                            {loadingHorarios ? (
                                <tr><td colSpan="5" className="text-center p-4 text-slate-500">A carregar horários...</td></tr>
                            ) : (tabSelecionada === 'ativos' ? horariosAtivos : horariosInativos).length > 0 ? (tabSelecionada === 'ativos' ? horariosAtivos : horariosInativos).map(horario => (
                            <tr key={horario.id} className={`hover:bg-slate-50 ${horario.data_especifica ? 'bg-indigo-50' : ''}`}>
                                <td className="px-6 py-4 font-medium text-slate-800">{horario.data_especifica ? (<span className="flex items-center gap-2 font-bold text-indigo-700"><CalendarDays size={16} />{formatarData(horario.data_especifica, horario.hora)}</span>) : (<span className="capitalize">{horario.dia_da_semana.replace('-feira', '')}</span>)}</td>
                                <td className="px-6 py-4 font-mono text-slate-600">{horario.data_especifica ? formatarData(horario.data_especifica, horario.hora).split(' ')[1] : horario.hora.slice(0, 5)}</td>
                                <td className="px-6 py-4 text-slate-800">{horario.rotulo}</td>
                                <td className="px-6 py-4 text-slate-800">
                                   {horario.ativo ? (
                                       <span className="px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-semibold">Ativo</span>
                                   ) : (
                                       <span className="px-2 py-1 rounded bg-red-100 text-red-700 text-xs font-semibold">Inativo</span>
                                   )}
                                   <button
                                       className={`ml-2 px-2 py-1 rounded text-xs font-semibold border ${horario.ativo ? 'border-red-400 text-red-600 hover:bg-red-50' : 'border-green-400 text-green-600 hover:bg-green-50'}`}
                                       onClick={() => handleToggleStatus(horario)}
                                       disabled={loadingHorarios}
                                   >{horario.ativo ? 'Inativar' : 'Ativar'}</button>
                                </td>
                                <td className="px-6 py-4 text-right space-x-2">
                                    <button onClick={() => { setHorarioSelecionado(horario); setModalFormAberto(true); setError(''); }} className="p-2 text-slate-500 hover:text-blue-600 hover:bg-blue-50 rounded-md" disabled={loadingHorarios}><Edit size={18} /></button>
                                    <button onClick={() => handleDelete(horario.id)} className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-md" disabled={loadingHorarios}><Trash2 size={18} /></button>
                                </td>
                            </tr>
                            )) : (
                                <tr><td colSpan="5" className="text-center p-8 text-slate-500">Nenhum horário {tabSelecionada === 'ativos' ? 'ativo' : 'inativo'} cadastrado para este grupo.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <ModalHorario isOpen={modalFormAberto} onClose={() => { setModalFormAberto(false); setError(''); }} onSave={handleSave} horario={horarioSelecionado} grupo={grupo} loadingHorarios={loadingHorarios} />
            {modalExcluirAberto && (<ModalExclusao onConfirm={excluirConfirmado} onCancel={() => { setModalExcluirAberto(false); setError(''); }} loading={loadingExcluir} />)}
        </div>
    );
}